function t(t){let e;return()=>(void 0===e&&(e=t()),e)}export{t as memo};
